import { emailLogGQLFields } from '../email/index.js';
import { memberGQLFields } from './member.fields.js';
import { roleGQLFields } from './role.fields.js';
const BASIC_MEMBER_INVITATION_FIELDS = {};
const ALL_MEMBER_INVITATION_FIELDS = {
    invitee: 'basic',
    inviter: 'basic',
    role: 'basic',
    emailLog: 'basic',
};
const DEFAULT_MEMBER_INVITATION_FIELDS = {
    inviter: { profilePicture: 'basic' },
    emailLog: 'basic',
    role: 'basic',
};
export function memberInvitationGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_MEMBER_INVITATION_FIELDS;
    if (fields === 'all')
        fields = ALL_MEMBER_INVITATION_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_MEMBER_INVITATION_FIELDS;
    return `
    createdAt
    expiresAt
    id
    invitationMessage
    inviteeEmail
    inviteeId
    inviteeName
    inviterId
    joinedAt
    networkId
    roleId
    status
    ${fields.invitee
        ? `
      invitee {
        ${memberGQLFields(fields.invitee)}
      }
    `
        : ``}
    ${fields.inviter
        ? `
      inviter {
        ${memberGQLFields(fields.inviter)}
      }
    `
        : ``}
    ${fields.role
        ? `
      role {
        ${roleGQLFields(fields.role)}
      }
    `
        : ``}
    ${fields.emailLog
        ? `
      emailLog {
        ${emailLogGQLFields()} 
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=memberInvitation.fields.js.map